﻿/*
 * Globalize Culture pl-PL
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("pl-PL", "default", {
    name: "pl-PL",
    englishName: "Polish (Poland)",
    nativeName: "polski (Polska)",
    language: "pl",
    numberFormat: {
      ",": " ",
      ".": ",",
      NaN: "nie jest liczbą",
      negativeInfinity: "-nieskończoność",
      positiveInfinity: "+nieskończoność",
      percent: {
        pattern: ["-n%", "n%"],
        ",": " ",
        ".": ","
      },
      currency: {
        pattern: ["-n $", "n $"],
        ",": " ",
        ".": ",",
        symbol: "zł"
      }
    },
    calendars: {
      standard: {
        "/": "-",
        firstDay: 1,
        days: {
          names: [
            "niedziela",
            "poniedziałek",
            "wtorek",
            "środa",
            "czwartek",
            "piątek",
            "sobota"
          ],
          namesAbbr: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
          namesShort: ["N", "Pn", "Wt", "Śr", "Cz", "Pt", "So"]
        },
        months: {
          names: [
            "styczeń",
            "luty",
            "marzec",
            "kwiecień",
            "maj",
            "czerwiec",
            "lipiec",
            "sierpień",
            "wrzesień",
            "październik",
            "listopad",
            "grudzień",
            ""
          ],
          namesAbbr: [
            "sty",
            "lut",
            "mar",
            "kwi",
            "maj",
            "cze",
            "lip",
            "sie",
            "wrz",
            "paź",
            "lis",
            "gru",
            ""
          ]
        },
        monthsGenitive: {
          names: [
            "stycznia",
            "lutego",
            "marca",
            "kwietnia",
            "maja",
            "czerwca",
            "lipca",
            "sierpnia",
            "września",
            "października",
            "listopada",
            "grudnia",
            ""
          ],
          namesAbbr: [
            "sty",
            "lut",
            "mar",
            "kwi",
            "maj",
            "cze",
            "lip",
            "sie",
            "wrz",
            "paź",
            "lis",
            "gru",
            ""
          ]
        },
        AM: null,
        PM: null,
        patterns: {
          d: "yyyy-MM-dd",
          D: "d MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "d MMMM yyyy HH:mm",
          F: "d MMMM yyyy HH:mm:ss",
          M: "d MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "Dodatkowa pomoc",
      AddNewTab: "Dodaj nową kartę",
      Alerts: "Alerty",
      ApplyFilter: "Zastosuj filtr",
      Approve: "Zatwierdź",
      Attachments: "Załączniki",
      Back: "Wstecz",
      Basic: "Podstawowe",
      Between: "Pomiędzy",
      Book: "Książka",
      Cancel: "Anuluj",
      Checked: "Zaznaczony",
      ClearFilter: "Wyczyść filtr",
      Close: "Zamknij",
      CloseCancelChanges: "Zamknij i anuluj zmiany",
      CloseSaveChanges: "Zamknij i zapisz zmiany",
      CloseTab: "Zamknij kartę",
      ColumnPersonalization: "Personalizacja kolumny",
      Comments: "Komentarze",
      Confirmation: "Potwierdzenie",
      Contains: "Zawiera",
      CreateTab: "Utwórz nową kartę",
      Cut: "Wytnij",
      Delete: "Usuń",
      DiscardUndo: "Odrzuć/cofnij",
      DisplayDropDownList: "Wyświetl listę rozwijaną",
      Displaying: "Wyświetlanie: ",
      DocWord: "Dokument",
      DoesNotContain: "Nie zawiera",
      DoesNotEndWith: "Nie kończy się na",
      DoesNotEqual: "Nie równa się",
      DoesNotStartWith: "Nie rozpoczyna się od",
      Download: "Pobierz",
      Duplicate: "Duplikuj",
      Edit: "Edytuj",
      EitherSelectedorNotSelected: "Wybrany albo niewybrany",
      Email: "Adres e-mail",
      EndsWith: "Kończy się na",
      EqualsStr: "Równa się",
      ExpandCollapse: "Rozwiń/zwiń",
      ExportFailed: "Eksport nie powiódł się",
      ExportToExcel: "Eksportuj do programu Excel",
      FileInUse: "Określony plik jest używany",
      FileInUseDetail:
        "Zamknij plik w aplikacji, w której jest on używany, lub określ inną nazwę pliku.",
      Filter: "Filtr",
      FilterMenu: "Menu filtru",
      FilterOptions: "Opcje filtru",
      FilterWithinResults: "Filtruj wyniki",
      First: "Pierwszy",
      FirstView: "Pierwszy widok",
      Folder: "Folder",
      ForgotPassword: "Nie pamiętasz hasła?",
      Forward: "Prześlij dalej",
      GetMoreRows: "Pobierz więcej wierszy",
      GreaterThan: "Większy niż",
      GreaterThanOrEquals: "Większy lub równy",
      GridSettings: "Ustawienia siatki",
      GroupSelection: "Wybór grupy",
      Help: "Pomoc",
      HideColumn: "Ukryj kolumnę",
      IsEmpty: "Jest pusty",
      IsNotEmpty: "Nie jest pusty",
      Last: "Ostatni",
      LastView: "Ostatni widok",
      LaunchActivate: "Uruchom/aktywuj",
      LessThan: "Mniejszy niż",
      LessThanOrEquals: "Mniejszy lub równy",
      Links: "Łącza",
      ListTabs: "Wyświetl listę wszystkich kart",
      LoadingItem: "Ładowanie elementu ",
      Maintenance: "Konserwacja",
      Menu: "Menu",
      New: "Nowy",
      Next: "Następny",
      NextView: "Następny widok",
      No: "Nie",
      NotChecked: "Niezaznaczony",
      Notes: "Uwagi",
      NotSelected: "Niewybrany",
      Of: " z ",
      Ok: "OK",
      Open: "Otwórz",
      Password: "Hasło",
      Paste: "Wklej",
      Phone: "Telefon",
      PleaseWait: "Czekaj",
      Previous: "Poprzedni",
      PreviousView: "Poprzedni widok",
      Print: "Drukuj",
      Queries: "Zapytania",
      Redo: "Wykonaj ponownie",
      Refresh: "Odśwież",
      Reject: "Odrzuć",
      RememberMe: "Zapamiętaj mnie na tym komputerze",
      Reports: "Raporty",
      Reset: "Resetuj",
      Review: "Przegląd",
      RunFilter: "Uruchom filtr",
      RunJob: "Uruchom zadanie",
      Save: "Zapisz",
      SaveBeforeClosing: "Zapisz przed zamknięciem",
      SavedFilters: "Zapisane filtry",
      SaveSubmit: "Zapisz/prześlij",
      ScreenDesign: "Projekt ekranu",
      Search: "Szukaj",
      SelectContents: "Wybierz zawartość",
      SelectDate: "Wybierz datę",
      SelectDeselect: "Zaznacz wszystko/anuluj zaznaczenie",
      Selected: "Wybrany: ",
      ServerName: "Nazwa serwera",
      Settings: "Ustawienia",
      ShowFilterRow: "Pokaż wiersz filtru",
      SignIn: "Zaloguj się",
      SortAscending: "Sortuj rosnąco",
      SortDescending: "Sortuj malejąco",
      Spreadsheet: "Arkusz kalkulacyjny",
      StartsWith: "Rozpoczyna się od",
      StatusIndicator: "Wskaźnik statusu",
      Tasks: "Zadania",
      Today: "Dzisiaj",
      Translate: "Przetłumacz",
      UserID: "Identyfikator użytkownika",
      Utilities: "Narzędzia",
      Yes: "Tak",
      Page: "Strona",
      Rows: "Wiersze",
      ShowingAll: "Pokazywanie wszystkich",
      SessionNavigation: "Nawigacja w obrębie sesji",
      ListAllMenuItems: "Wyświetl listę wszystkich elementów menu",
      NoRecordsFound: "Nie znaleziono rekordów",
      SearchTree: "Przeszukaj drzewo",
      Clear: "Wyczyść",
      DrillDown: "Poziom szczegółów",
      Required: "To pole jest wymagane",
      Available: "Dostępny:",
      Add: "Dodaj",
      MoveDown: "Przenieś w dół",
      MoveUp: "Przenieś w górę",
      Remove: "Usuń",
      LastYear: "W ubiegłym roku",
      NextMonth: "W przyszłym miesiącu",
      NextWeek: "W przyszłym tygodniu",
      NextYear: "W przyszłym roku",
      OneMonthAgo: "Miesiąc temu",
      OneWeekAgo: "Tydzień temu",
      SixMonthsAgo: "Sześć miesięcy temu",
      Time: "Czas",
      CannotBeSelected: "Nie można wybrać tego wiersza.",
      ResetToDefault: "Resetuj do układu domyślnego",
      CloseOtherTabs: "Zamknij inne karty",
      EmailValidation: "Wprowadź prawidłowy adres e-mail",
      UrlValidation: "Wprowadź prawidłowy adres URL",
      EndofResults: "Koniec wyników",
      More: "Więcej...",
      RecordsPerPage: "Liczba rekordów na stronie",
      Maximize: "Maksymalizuj",
      Minimize: "Zminimalizować"
    }
  });
})(this);
